import { render, staticRenderFns } from "./PromoCode.vue?vue&type=template&id=1810944b&scoped=true"
import script from "./PromoCode.vue?vue&type=script&lang=js"
export * from "./PromoCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1810944b",
  null
  
)

export default component.exports